import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useConvexAuth } from "convex/react";
import SigninPage from "../Modules/Authentication/Page/SigninPage";
import { useTenantStore } from "../stores/useTenantStore";
import { Spinner } from "flowbite-react";
import { resolveDefaultTenantRoute } from "./tenantUtils";

const RedirectToBudgetIfLoggedIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUserTenants } = useTenantStore();
  const { isLoading, isAuthenticated } = useConvexAuth();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    // Check for ?next= param (e.g. from JoinPage redirect)
    const params = new URLSearchParams(location.search);
    const next = params.get("next");
    if (next) {
      navigate(next);
      return;
    }

    // Resolve tenant and navigate
    resolveDefaultTenantRoute("home")
      .then(async (targetRoute) => {
        await fetchUserTenants();
        navigate(targetRoute);
      })
      .catch((err) => {
        console.error("[RedirectToBudgetIfLoggedIn]", err);
        navigate("/");
      });
  }, [isLoading, isAuthenticated, navigate, fetchUserTenants, location.search]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirecting — show spinner while effect fires
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  return <SigninPage />;
};

export default RedirectToBudgetIfLoggedIn;
